<div class="no-scroll patient-ob">
  <div class="wrapper">
    <!-- ========================== Print History Popup (Start) ========================== -->
    <div *ngIf="showPrintHistoryPopup" class="print-history-popup">
      <div class="print-history-popup-body">
        <h2 class="popup-title">
          {{ 'GUI.Patient History.PrintHistory.Print History' | translate }}
        </h2>
        <button
          (click)="togglePrintHistoryPopup()"
          class="print-history-popup-close"
          aria-label="close popup"
        ></button>

        <img *ngIf="loadingPrint" src="../../assets/images/Wedges.svg" class="pdf-loader" />

        <table
          mat-table
          [dataSource]="printHistoryData"
          *ngIf="!loadingPrint"
          class="mat-elevation-z8 print-table"
        >
          <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let element">
              {{ printHistoryData.indexOf(element) + 1 }}
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'GUI.Patient History.PrintHistory.Date' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.creationDate | date: 'dd/MM/yyyy' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="time">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'GUI.Patient History.PrintHistory.Hour' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.creationTime }}
            </td>
          </ng-container>

          <ng-container matColumnDef="comments">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'GUI.Patient History.PrintHistory.Comments' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element?.comments }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            (click)="printSelectPDF(row)"
            [class.demo-row-is-clicked]="clickedRows.has(row)"
            *matRowDef="let row; columns: displayedColumns"
          ></tr>
        </table>
      </div>
    </div>
    <!-- ========================== Print History Popup (End) ========================== -->

    <!-- ========================== Consent Type Popup (Start) ========================== -->
    <div *ngIf="showGynConsentSelect" class="print-history-popup">
      <div class="print-history-popup-body">
        <h2 class="popup-title">Select Consent Type</h2>
        <button
          (click)="showGynConsentSelect = false"
          class="print-history-popup-close"
          aria-label="close popup"
        ></button>
        <div>
          <div class="l-flex-c l-flex-w l-justify h50 placenta-row" style="margin-top: 1em">
            <label class="t-label-top">
              <span> Consent type </span>
              <select class="t-select t-field" [(ngModel)]="selectedGynConsentType">
                <option value="" disabled></option>
                <option value="Hysterosalpingo Sonography">Hysterosalpingo Sonography</option>
                <option value="Insertion of IUD">Insertion of IUD</option>
              </select>
            </label>
          </div>
          <div style="display: flex; justify-content: space-around; margin-top: 1em">
            <button class="orange-btn" (click)="closeGYNConsentSelect('continueWithoutConsent')">
              Continue Without
            </button>
            <button
              class="blue-btn"
              (click)="closeGYNConsentSelect('openForm')"
              [disabled]="!selectedGynConsentType"
              [style.opacity]="selectedGynConsentType ? '1' : '0.5'"
              [style.cursor]="selectedGynConsentType ? 'pointer' : 'not-allowed'"
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- ========================== Consent Type Popup (End) ========================== -->

    <!-- ========================== Consent Agreement Popup (Start) ========================== -->
    <div *ngIf="showConsentAgreementPopup" class="print-history-popup">
      <div class="print-history-popup-body consent-agreement-popup">
        <h2 class="popup-title">Consent Form Agreement</h2>
        <button
          (click)="handleConsentAgreement(false)"
          class="print-history-popup-close"
          aria-label="close popup"
        ></button>

        <div class="consent-agreement-content">
          <p style="text-align: justify; line-height: 1.6; margin: 20px 0">
            Artisan Sonics is only displaying and enabling you to digitally store, sign, and have
            the patient's signature, the selection of the consent form type digitally, its
            adaptability, and the content is your responsibility only. The forms are made by the
            Israeli medical association (IMA) הר"י and ArtisanSonics will not be held responsible
            for their use under any circumstances.
          </p>

          <div
            style="
              margin-top: 30px;
              display: flex;
              gap: 15px;
              align-items: center;
              justify-content: center;
              flex-wrap: wrap;
            "
          >
            <label style="display: flex; align-items: center; gap: 8px; cursor: pointer">
              <input
                type="checkbox"
                #dontShowAgain
                style="width: 18px; height: 18px; cursor: pointer"
              />
              <span>Don't show again</span>
            </label>

            <button
              (click)="handleConsentAgreement(true, dontShowAgain.checked)"
              style="
                padding: 10px 30px;
                background: #177b8e;
                color: white;
                border: none;
                border-radius: 5px;
                cursor: pointer;
                font-size: 16px;
              "
            >
              Yes
            </button>

            <button
              (click)="handleConsentAgreement(false)"
              style="
                padding: 10px 30px;
                background: #dcb16b;
                color: white;
                border: none;
                border-radius: 5px;
                cursor: pointer;
                font-size: 16px;
              "
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- ========================== Consent Agreement Popup (End) ========================== -->

    <!-- ========================== header (start) ========================== -->
    <app-page-header>
      <div class="l-header-panel">
        <h1 class="t-title-main" *ngIf="isDefaultsPage">Defaults</h1>
        <i class="off-mobile header-icon icon-fetus" *ngIf="false"></i>

        <div class="header-pagi" *ngIf="false">
          <a href="#" class="header-pagi-item">1</a>
          <a href="#" class="header-pagi-item is-active">2</a>
          <a href="#" class="header-pagi-item">3</a>
        </div>

        <nav class="header-menu" style="display: flex; align-items: center">
          <!-- <a href="#" class="header-menu-link icon-book" aria-label="library"></a> -->
          <!-- <a href="#" class="header-menu-link icon-print" aria-label="Print"></a> -->
          <span
            *ngIf="!isDefaultsPage && login.premissions && login.premissions?.uploadDocuments"
            style="margin-right: 2em"
            class="header-icon-btn header-icon-btn--lg icon-upload"
            matTooltip="{{ 'GUI.documents.tooltips.Attach Document' | translate }}"
            (click)="openDocumentsAdd = true"
          ></span>
          <span
            *ngIf="!isDefaultsPage && login.premissions?.Billings"
            style="margin-right: 2em"
            class="header-icon-btn header-icon-btn--lg icon-billings"
            [matTooltip]="'GUI.Tooltips.Get Invoice' | translate"
            (click)="redirectAdministration('billing')"
          ></span>
          <span
            *ngIf="!isDefaultsPage && login.premissions?.Appointments"
            class="header-icon-btn header-icon-btn--lg icon-appointment"
            [matTooltip]="'GUI.Tooltips.Set Appointment' | translate"
            (click)="redirectAdministration('appointments')"
          ></span>
          <a
            *ngIf="!isDefaultsPage && login.premissions?.Planner"
            (click)="calendarForm = true; selectedForm = null; cf.selcForm = null"
            class="header-menu-link icon-calendar"
            [matTooltip]="'GUI.Tooltips.Pregnancy Planner' | translate"
            style="background-color: white; border-radius: 5px; cursor: pointer"
            aria-label="calendar"
          ></a>
          <!-- <a href="#" class="header-menu-link icon-chart" aria-label="chart"></a> -->
          <!-- <a href="#" class="header-menu-link icon-image" aria-label="image"></a> -->
          <!-- <a href="#" class="header-menu-link icon-searchdoc" aria-label="image"></a> -->
          <!-- <a href="#" class="header-menu-link icon-save" aria-label="save"></a> -->
          <!-- <a href="#" class="header-menu-link icon-date" aria-label="date"></a> -->
          <!-- <a href="#" class="header-menu-link icon-confirm" aria-label="confirm"></a> -->
        </nav>

        <nav class="on-mobile header-mobilePanel">
          <button
            class="btn-mobileMenu"
            id="open-headerMenu"
            data-show=".header-menu"
            aria-label="open mobile menu"
          ></button>
          <button
            class="btn-mobileMenu"
            id="open-mainNav"
            data-show=".l-sidebar"
            aria-label="open mobile sidebar"
          ></button>
        </nav>
      </div>
    </app-page-header>
    <!-- ========================== header (end) ========================== -->

    <!-- ========================== Dashboard Main Content (Start) ========================== -->

    <main class="l-deashboard">
      <div class="h100 l-flex l-flex-w t-boxMargin--spacebyPadding">
        <!-- ========================== Patient History Panel (Start) ========================== -->
        <div class="w50 patient-ob-box">
          <div class="h100 m-box" *ngIf="isDefaultsPage" [formGroup]="examServe.newTitleItem">
            <h2>Additional Titles Setting</h2>
            <div class="h100 l-flex l-column" style="justify-content: space-between">
              <div>
                <div class="headDiv">
                  <div class="inputLine">
                    <section>
                      <span>Define new title:</span>
                      <input
                        class="input"
                        #inputTitle
                        type="text"
                        formControlName="Title"
                        [value]="examServe.newTitleItem.get('Title').value"
                      />
                    </section>
                    <span class="t-validation-wrap l-fg1" style="text-align: center">
                      <span class="s-count" *ngIf="examServe.CustomTitles">
                        <span [ngClass]="!examServe.disableSaveTitle ? '' : 'is-invalid'">
                          <strong>
                            {{ examServe.CustomTitles ? examServe.CustomTitles?.length : 0 }}/8
                          </strong>
                        </span>
                        <div class="t-validation-message">
                          <span>Maximum Custom Titles, Please Remove One</span>
                        </div>
                      </span>
                    </span>
                    <button
                      (click)="examServe.saveNewTitle(login.ClinicID, false)"
                      style="
                        background-color: #d7a95b;
                        color: white;
                        width: 4em;
                        border-radius: 10px;
                      "
                    >
                      save
                    </button>
                  </div>
                </div>
                <div>
                  <div
                    class="linked-radios-list linked-radios-set"
                    style="margin-top: 0"
                    [formGroup]="examServe.newTitleItem"
                  >
                    <label class="linked-radios-item" *ngFor="let c of examServe.CustomTitles">
                      <input
                        type="radio"
                        [value]="c.AutoIndex"
                        formControlName="AutoIndex"
                        (click)="examServe.getTitle(c.AutoIndex)"
                      />
                      <span class="linked-radios-row">
                        <span
                          class="l-fg1 linked-radios-title"
                          (dblclick)="examServe.resetTitleItem()"
                        >
                          {{ c.Title }}
                        </span>
                        <span class="linked-radios-duration" style="margin-inline-end: 5em">
                          <p>
                            {{ c.Creation | date: 'dd/MM/yyyy' }}
                            {{ 'GUI.Patient History.at' | translate }}

                            {{ c.Creation | date: 'HH:mm' }}
                          </p>
                        </span>
                        <span class="linked-radios-duration"
                          ><img
                            src="../../assets/icons/del.svg"
                            matTooltip="Delete"
                            (click)="examServe.deleteTitle(c.AutoIndex)"
                        /></span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
              <!-- Signature Upload Section -->
              <div
                *ngIf="login.userType === 'doctor' && login.premissions?.Consent"
                style="
                  margin-top: 1.5em;
                  padding: 1em;
                  border: 1px solid #e0e0e0;
                  border-radius: 8px;
                "
              >
                <h3 style="margin: 0 0 0.5em 0">Doctor Signature</h3>
                <div
                  *ngIf="signatureLoading"
                  style="display: flex; align-items: center; gap: 0.5em"
                >
                  <span>Loading...</span>
                </div>
                <div *ngIf="!signatureLoading && currentSignatureUrl" style="margin-bottom: 0.5em">
                  <img
                    [src]="currentSignatureUrl"
                    style="max-height: 80px; border: 1px solid #ccc; border-radius: 4px"
                    alt="Current Signature"
                  />
                </div>
                <div class="l-flex l-flex-c" style="gap: 0.5em">
                  <input
                    type="file"
                    #signatureFile
                    accept="image/*"
                    style="display: none"
                    (change)="onSignatureFileSelected($event)"
                  />
                  <button
                    class="accept"
                    (click)="signatureFile.click()"
                    [disabled]="signatureLoading"
                    style="min-width: auto; height: auto; padding: 0.4em 1em"
                  >
                    {{ currentSignatureUrl ? 'Replace Signature' : 'Upload Signature' }}
                  </button>
                  <button
                    class="cancel"
                    *ngIf="currentSignatureUrl"
                    (click)="deleteSignature()"
                    [disabled]="signatureLoading"
                    style="min-width: auto; height: auto; padding: 0.4em 1em"
                  >
                    Delete Signature
                  </button>
                  <span *ngIf="signatureUploadStatus" style="color: green; font-size: 0.9em">{{
                    signatureUploadStatus
                  }}</span>
                </div>
              </div>

              <!-- Secretary: Manage Doctor Signatures -->
              <div
                *ngIf="
                  login.userType === 'secretary' &&
                  login.premissions?.Consent &&
                  clinicPractitioners?.length
                "
                style="
                  margin-top: 1.5em;
                  padding: 1em;
                  border: 1px solid #e0e0e0;
                  border-radius: 8px;
                "
              >
                <h3 style="margin: 0 0 0.75em 0">Doctor Signatures</h3>
                <div
                  *ngFor="let p of clinicPractitioners"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 1em;
                    padding: 0.5em 0;
                    border-bottom: 1px solid #f0f0f0;
                  "
                >
                  <span style="min-width: 10em; font-weight: 500">{{ p.Title }} {{ p.Name }}</span>
                  <ng-container *ngIf="practitionerSignatures[p.UID] as sig">
                    <span *ngIf="sig.loading" style="font-size: 0.85em; color: #888"
                      >Loading...</span
                    >
                    <img
                      *ngIf="!sig.loading && sig.url"
                      [src]="sig.url"
                      style="
                        max-height: 50px;
                        max-width: 120px;
                        border: 1px solid #ccc;
                        border-radius: 4px;
                        cursor: zoom-in;
                        transition: transform 0.2s;
                        position: relative;
                        z-index: 1;
                      "
                      (mouseenter)="
                        $event.target.style.transform = 'scale(3)';
                        $event.target.style.zIndex = '100'
                      "
                      (mouseleave)="
                        $event.target.style.transform = 'scale(1)'; $event.target.style.zIndex = '1'
                      "
                      alt="Signature"
                    />
                    <span *ngIf="!sig.loading && !sig.url" style="font-size: 0.85em; color: #aaa"
                      >No signature</span
                    >
                    <input
                      type="file"
                      #sigFileInput
                      accept="image/*"
                      style="display: none"
                      (change)="onPractitionerSignatureSelected(p.UID, $event)"
                    />
                    <button
                      class="accept"
                      (click)="sigFileInput.click()"
                      [disabled]="sig.loading"
                      style="min-width: auto; height: auto; padding: 0.3em 0.8em; font-size: 0.85em"
                    >
                      {{ sig.url ? 'Replace' : 'Upload' }}
                    </button>
                    <button
                      class="cancel"
                      *ngIf="sig.url"
                      (click)="deletePractitionerSignature(p.UID)"
                      [disabled]="sig.loading"
                      style="min-width: auto; height: auto; padding: 0.3em 0.8em; font-size: 0.85em"
                    >
                      Delete
                    </button>
                    <span *ngIf="sig.status" style="color: green; font-size: 0.8em">{{
                      sig.status
                    }}</span>
                  </ng-container>
                </div>
              </div>
              <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">
                <a class="patient-ob-btn -exit_patient" routerLink="/patsearch">
                  Exit Titles Setting
                </a>
              </div>
            </div>
          </div>
          <div class="h100 m-box" *ngIf="!isDefaultsPage">
            <h2>
              {{ 'GUI.Patient History.Patient History' | translate | titlecase }}
            </h2>
            <!-- ========================== Pregnancy with LMP (Start) ========================== -->
            <div class="linked-radios-list linked-radios-set" *ngFor="let preg of pregnancies">
              <strong
                class="linked-radios-row"
                *ngIf="(preg.calendarForms && preg.calendarForms?.length > 0) || preg.exams"
              >
                {{ 'GUI.Patient History.Pregnancy with LMP' | translate }}
                {{ preg.LMP | date: 'dd/MM/yyyy' }}

                <span
                  class="linked-radios-date"
                  style="position: absolute; right: 0.5em; font-size: 11pt; cursor: pointer"
                  (click)="closePreg = preg.AutoIndex; pregExams = preg.exams"
                  *ngIf="
                    preg.ClosedDate ||
                    login.userType === 'doctor' ||
                    login.userType === 'tech' ||
                    login.userType === 'visitingdoc'
                  "
                  >{{
                    preg.ClosedDate
                      ? ('GUI.Patient History.Closed on' | translate) +
                        ' ' +
                        (preg.ClosedDate | date: 'dd/MM/yyyy')
                      : ('GUI.Patient History.Close' | translate)
                  }}
                </span>
              </strong>
              <ul *ngIf="preg.exams">
                <li class="l-flex l-flex-c">
                  <span style="width: 40%">
                    <strong>
                      {{ 'GUI.Patient History.Exam Name' | translate | titlecase }}
                    </strong>
                  </span>
                  <span style="width: 40%">
                    <strong>
                      {{ 'GUI.Patient History.Main Diagnosis' | translate | titlecase }}
                    </strong>
                  </span>
                  <span style="width: 25%">
                    <strong>
                      {{ 'GUI.Patient History.Done by' | translate | titlecase }}
                    </strong>
                  </span>
                </li>
              </ul>

              <ul>
                <li class="l-flex l-flex-c" *ngFor="let exam of preg.exams">
                  <span
                    class="examlink"
                    style="display: flex; position: relative; width: 100%; align-items: center"
                    [ngClass]="switchMainDiagnosisContent(exam) !== null ? 'd-main' : ''"
                    (contextmenu)="askDelete(exam)"
                  >
                    <span style="width: 35%">
                      <span
                        (click)="goExam(preg, exam, exam.ExamType, exam.CreationTime)"
                        style="margin-inline-end: 5px"
                        [matTooltip]="
                          canView(exam) ? '' : ('GUI.Patient History.LockedByMsg' | translate)
                        "
                      >
                        {{ 'GUI.Patient History.ExamTypes.OB.' + exam.ExamType | translate }}
                        <!-- {{ exam.ExamType }}  -->
                        <!-- <strong> 
                          {{ exam?.hasAnatomyNote ? '(N)' : '' }}
                        </strong> -->
                      </span>
                      <span *ngIf="exam.Changed"> ({{ exam.ChangedExamTitle }}) </span>
                      <ng-container *ngIf="exam.Locked">
                        <img
                          src="../../assets/icons/login/password.svg"
                          style="height: 1em; margin-left: 1em"
                        />
                        {{ exam.LockedBy }}
                      </ng-container>
                      <ng-container *ngIf="getConcent(exam) && login.premissions?.Consent && false">
                        <img
                          *ngIf="false"
                          src="../../assets/icons/login/text-file-icon.svg"
                          style="height: 1.5em; width: 1.5em"
                          matTooltip="Open Concent Form"
                          (click)="startForm(getConcent(exam))"
                        />
                      </ng-container>
                    </span>

                    <img
                      [ngClass]="
                        examServe.awaitPrintHistory
                          ? 'print-history-icon-disabled'
                          : 'print-history-icon'
                      "
                      src="../../assets/icons/print-history.svg"
                      matTooltip="{{
                        showPrintHistoryPopup
                          ? ('GUI.Patient History.PrintHistory.Close Print History' | translate)
                          : ('GUI.Patient History.PrintHistory.Open Print History' | translate)
                      }}"
                      [matTooltipDisabled]="examServe.awaitPrintHistory"
                      (click)="togglePrintHistoryPopup(); getPrintHistoryList(exam)"
                    />

                    <img
                      *ngIf="exam.ReferralId"
                      src="../../assets/icons/blood-test-referral.svg"
                      style="height: 1.5em; cursor: pointer; background:#277382; border:1px solid #277382; border-radius:4px; padding:3px; box-sizing:content-box; vertical-align:middle"
                      matTooltip="הפניה לבדיקות מעבדה (לחיצה ימנית למחיקה)"
                      (click)="openReferralPrintout(exam.ReferralId)"
                      (contextmenu)="askDeleteReferral(exam, $event)"
                    />

                    <span
                      style="width: 35%"
                      class="diagnosis anotomy-show-more"
                      (click)="goExam(preg, exam, exam.ExamType, exam.CreationTime)"
                    >
                      <img
                        *ngIf="switchMainDiagnosisContent(exam) !== null"
                        class="show-more-diagnosis-icon"
                        src="../../assets/icons/anatomy-plus.svg"
                      />
                      <span *ngIf="!switchMainDiagnosisContent(exam) && !showDiagnosisComments">
                        {{ 'GUI.Patient History.No relevant data' | translate }}
                      </span>
                    </span>
                    <span class="d-span" *ngIf="switchMainDiagnosisContent(exam) !== null">
                      <div class="d-span-body">
                        <div class="d-span-details">
                          <div
                            *ngIf="switchMainDiagnosisContent(exam) !== null"
                            [ngClass]="
                              switchMainDiagnosisContent(exam) === ''
                                ? 'd-span-line'
                                : 'd-span-desc'
                            "
                            [innerHTML]="switchMainDiagnosisContent(exam)"
                          ></div>
                          <div
                            *ngIf="showDiagnosisComments"
                            [ngClass]="
                              displayDiagnosisComments(exam) === '' ? 'd-span-line' : 'd-span-desc'
                            "
                          >
                            {{ displayDiagnosisComments(exam) }}
                          </div>
                        </div>
                      </div>
                    </span>

                    <span style="width: 20%">
                      {{ 'GUI.Patient History.by' | translate }}
                      {{ exam.Opener }}
                    </span>
                    <span style="width: 20%" class="linked-radios-date">
                      {{ exam.CreationTime | date: 'dd/MM/yyyy' }}
                      {{ 'GUI.Patient History.at' | translate }}
                      {{ exam.CreationTime | date: 'HH:mm' }}
                    </span>
                  </span>
                </li>
              </ul>
              <div
                style="margin-top: 1em"
                *ngIf="
                  (preg.calendarForms && preg.calendarForms.length > 0) ||
                  (preg.forms && preg.forms.length)
                "
              >
                <strong class="linked-radios-row">
                  {{ 'GUI.Patient History.Forms' | translate }}
                </strong>

                <ul>
                  <li
                    class="l-flex l-flex-c"
                    style="border-bottom: 1px solid #bdd3d5; margin-bottom: 1em"
                    *ngFor="let form of preg.calendarForms"
                  >
                    <span
                      class="l-fg1 examlink"
                      (click)="loadCalendarForm(form)"
                      (contextmenu)="askDelete(form, false, false, false, true)"
                    >
                      {{ 'GUI.Patient History.Pregnancy Planner' | translate }}
                    </span>
                    <span style="margin-right: 2em">
                      {{ 'GUI.Patient History.by' | translate }}
                      {{ form.Opener }}
                    </span>
                    <span class="linked-radios-date">
                      {{ form.CreationTime | date: 'dd/MM/yyyy' }}

                      {{ 'GUI.Patient History.at' | translate }}

                      {{ form.CreationTime | date: 'HH:mm' }}
                    </span>
                  </li>
                </ul>
                <!-- ========================== Pregnancy Consent Forms (Start) ========================== -->
                <ul *ngIf="preg.forms && preg.forms.length > 0">
                  <li
                    class="l-flex l-flex-c"
                    *ngFor="let concent of preg.forms | sortCreationTime: 'CreationTime'"
                  >
                    <span
                      class="l-fg1 examlink"
                      (click)="startForm(concent)"
                      (contextmenu)="askDelete(concent, true)"
                    >
                      Consent form For {{ concent.ExamType }}
                    </span>

                    <div
                      [ngClass]="
                        checkApprovedConcent(concent) ? 'signed-consent' : 'not-signed-consent'
                      "
                      [matTooltip]="
                        checkApprovedConcent(concent)
                          ? ('GUI.Tooltips.Consent Signed' | translate)
                          : ('GUI.Tooltips.Consent Not Signed' | translate)
                      "
                    ></div>
                    <!-- @if (concent.ExamID) {
                      <mat-icon
                        class="concent-linked-icon"
                        [matTooltip]="'GUI.Tooltips.Consent Linked' | translate"
                        >link</mat-icon
                      >
                    } -->
                    <!-- @if (isConcentExpired(concent)) {
                      <mat-icon
                        class="concent-expired-icon"
                        [matTooltip]="'GUI.Tooltips.Consent Expired' | translate"
                        >warning_amber</mat-icon
                      >
                    } -->
                    <span style="margin-right: 2em">
                      {{ 'GUI.Patient History.by' | translate }}
                      {{ concent.Opener }}
                    </span>
                    <span class="linked-radios-date"
                      >{{ concent.CreationTime | date: 'dd/MM/yyyy' }}
                      {{ 'GUI.Patient History.at' | translate }}
                      {{ concent.CreationTime | date: 'HH:mm' }}</span
                    >
                  </li>
                </ul>
                <!-- ========================== Pregnancy Consent Forms (End) ========================== -->
              </div>
            </div>
            <!-- ========================== Pregnancy with LMP (End) ========================== -->

            <!-- ========================== Questionnaires (Start) ========================== -->
            <!-- Patient-level (not per-pregnancy) — independent of consent forms. -->
            <div
              class="linked-radios-list linked-radios-set"
              *ngIf="login.premissions?.Questionnaires && patientQuestionnaires && patientQuestionnaires.length > 0"
            >
              <strong class="linked-radios-row">
                {{ 'GUI.General.Buttons.Questionnaires' | translate }}
              </strong>
              <ul>
                <li
                  class="l-flex l-flex-c"
                  *ngFor="let q of patientQuestionnaires"
                >
                  <span
                    class="l-fg1 examlink"
                    [style.cursor]="q.answeredDate ? 'pointer' : 'default'"
                    (click)="q.answeredDate && openQuestionnairePdf(q)"
                  >
                    {{ q.name }}
                  </span>

                  <div
                    [ngClass]="
                      q.answeredDate ? 'signed-consent' : 'not-signed-consent'
                    "
                  ></div>
                  <span class="linked-radios-date">{{
                    (q.answeredDate || q.sentDate) | date: 'dd/MM/yyyy'
                  }}</span>
                </li>
              </ul>
            </div>
            <!-- ========================== Questionnaires (End) ========================== -->

            <!-- ========================== Other Exams (Start) ========================== -->
            <div
              class="linked-radios-list linked-radios-set"
              *ngIf="notFormExams && notFormExams.length > 0"
            >
              <strong class="linked-radios-row" style="margin-bottom: 2%">
                {{ 'GUI.Patient History.Other Exams' | translate }}
              </strong>
              <ul>
                <li class="l-flex l-flex-c" *ngFor="let exam of notFormExams | uniqueAutoIndex">
                  <ng-container *ngIf="!FORMS.includes(exam.ExamType)">
                    <span
                      class="examlink"
                      style="display: flex; position: relative; width: 100%; align-items: center"
                      [ngClass]="switchMainDiagnosisContent(exam) !== null ? 'd-main' : ''"
                    >
                      <span
                        style="width: 35%"
                        (click)="goExam(null, exam, exam.ExamType, exam.CreationTime)"
                        (contextmenu)="askDelete(exam)"
                      >
                        {{ 'GUI.Patient History.ExamTypes.GYN.' + exam.ExamType | translate }}
                      </span>
                      <span *ngIf="exam.Changed"> ({{ exam.ChangedExamTitle }}) </span>
                      <ng-container *ngIf="exam.Locked">
                        <img src="../../assets/icons/login/password.svg" style="height: 1em" />
                        {{ exam.LockedBy }}
                      </ng-container>

                      <img
                        [ngClass]="
                          examServe.awaitPrintHistory
                            ? 'print-history-icon-disabled'
                            : 'print-history-icon'
                        "
                        src="../../assets/icons/print-history.svg"
                        matTooltip="{{
                          showPrintHistoryPopup
                            ? ('GUI.Patient History.PrintHistory.Close Print History' | translate)
                            : ('GUI.Patient History.PrintHistory.Open Print History' | translate)
                        }}"
                        [matTooltipDisabled]="examServe.awaitPrintHistory"
                        (click)="togglePrintHistoryPopup(); getPrintHistoryList(exam)"
                      />

                      <img
                        *ngIf="exam.ReferralId"
                        src="../../assets/icons/blood-test-referral.svg"
                        style="height: 1.5em; cursor: pointer; background:#277382; border:1px solid #277382; border-radius:4px; padding:3px; box-sizing:content-box; vertical-align:middle"
                        matTooltip="הפניה לבדיקות מעבדה (לחיצה ימנית למחיקה)"
                        (click)="openReferralPrintout(exam.ReferralId)"
                        (contextmenu)="askDeleteReferral(exam, $event)"
                      />

                      <span
                        class="diagnosis anotomy-show-more"
                        style="width: 35%"
                        (click)="goExam(null, exam, exam.ExamType, exam.CreationTime)"
                      >
                        <img
                          *ngIf="switchMainDiagnosisContent(exam) !== null"
                          class="show-more-diagnosis-icon"
                          src="../../assets/icons/anatomy-plus.svg"
                        />
                        <span *ngIf="!switchMainDiagnosisContent(exam) && !showDiagnosisComments">
                          {{ 'GUI.Patient History.No relevant data' | translate }}
                        </span>
                      </span>
                      <span class="d-span" *ngIf="switchMainDiagnosisContent(exam) !== null">
                        <div class="d-span-body">
                          <div class="d-span-details">
                            <div
                              *ngIf="switchMainDiagnosisContent(exam) !== null"
                              [ngClass]="
                                switchMainDiagnosisContent(exam) === ''
                                  ? 'd-span-line'
                                  : 'd-span-desc'
                              "
                              [innerHTML]="switchMainDiagnosisContent(exam)"
                            ></div>
                            <div
                              *ngIf="showDiagnosisComments"
                              [ngClass]="
                                displayDiagnosisComments(exam) === ''
                                  ? 'd-span-line'
                                  : 'd-span-desc'
                              "
                            >
                              {{ displayDiagnosisComments(exam) }}
                            </div>
                          </div>
                        </div>
                      </span>

                      <span style="width: 20%">
                        {{ 'GUI.Patient History.by' | translate }}
                        {{ exam.Opener }}</span
                      >
                      <span style="width: 20%" class="linked-radios-date">
                        {{ exam.CreationTime | date: 'dd/MM/yyyy' }}

                        {{ 'GUI.Patient History.at' | translate }}

                        {{ exam.CreationTime | date: 'HH:mm' }}
                      </span>
                    </span>
                  </ng-container>
                </li>
              </ul>
            </div>
            <!-- ========================== Other Exams (End) ========================== -->

            <!-- ========================== Other (Unlinked) Consent Form (Start) ========================== -->
            <div
              style="margin-top: 1em; padding-left: 1.8em"
              *ngIf="unlinkedConsents?.length && login.premissions?.Consent"
            >
              <!-- <strong class="linked-radios-row">Other Consent Forms </strong> -->

              <li
                class="l-flex l-flex-c unlinked-concent-row"
                *ngFor="let concent of unlinkedConsents | sortCreationTime: 'CreationTime'"
              >
                <span
                  class="l-fg1 examlink"
                  (click)="startForm(concent)"
                  (contextmenu)="askDelete(concent, false, false, true)"
                >
                  Consent form For {{ concent.ExamType }}
                </span>
                <div
                  [ngClass]="
                    checkApprovedConcent(concent) ? 'signed-consent' : 'not-signed-consent'
                  "
                  [matTooltip]="
                    checkApprovedConcent(concent)
                      ? ('GUI.Tooltips.Consent Signed' | translate)
                      : ('GUI.Tooltips.Consent Not Signed' | translate)
                  "
                ></div>
                <span style="margin-right: 2em">
                  {{ 'GUI.Patient History.by' | translate }}
                  {{ concent.Opener }}
                </span>
                <span class="linked-radios-date">
                  {{ concent.CreationTime | date: 'dd/MM/yyyy' }}
                  {{ 'GUI.Patient History.at' | translate }}

                  {{ concent.CreationTime | date: 'HH:mm' }}
                </span>
              </li>
            </div>
            <!-- ========================== Other (Unlinked) Consent Form (End) ========================== -->

            <!-- ========================== Gynecology Consent Forms (Start) ========================== -->
            <div style="margin-top: 1em" *ngIf="gynConsents?.length && login.premissions?.Consent">
              <strong class="linked-radios-row"> Gynecology Consent Forms </strong>

              <ul *ngIf="gynConsents && gynConsents.length > 0" style="padding: 0">
                <li
                  class="l-flex l-flex-c"
                  style="
                    height: 3em;
                    border-bottom: 1px solid #bdd3d5;
                    margin: 0 1.12em;
                    margin-right: 0.56em;
                  "
                  *ngFor="let concent of gynConsents | sortCreationTime: 'CreationTime'"
                >
                  <span
                    class="l-fg1 examlink"
                    (click)="startGynForm(concent)"
                    (contextmenu)="askDelete(concent, false, true)"
                  >
                    Consent form For {{ concent.GynConsentType }}
                  </span>

                  <div
                    [ngClass]="
                      checkApprovedConcent(concent) ? 'signed-consent' : 'not-signed-consent'
                    "
                    [matTooltip]="
                      checkApprovedConcent(concent)
                        ? ('GUI.Tooltips.Consent Signed' | translate)
                        : ('GUI.Tooltips.Consent Not Signed' | translate)
                    "
                  ></div>
                  <span style="margin-right: 2em">
                    {{ 'GUI.Patient History.by' | translate }}
                    {{ concent.Opener }}
                  </span>
                  <span class="linked-radios-date"
                    >{{ concent.CreationTime | date: 'dd/MM/yyyy' }}
                    {{ 'GUI.Patient History.at' | translate }}
                    {{ concent.CreationTime | date: 'HH:mm' }}</span
                  >
                </li>
              </ul>
            </div>
            <!-- ========================== Gynecology Consent Forms (End) ========================== -->

            <div
              class="linked-radios-list linked-radios-set"
              *ngIf="formsExams && formsExams?.length > 0"
            >
              <strong class="linked-radios-row">
                {{ 'GUI.Patient History.ExamTypes.Letters and Certificates' | translate }}
              </strong>

              <ul>
                <li class="l-flex l-flex-c" *ngFor="let exam of formsExams | uniqueAutoIndex">
                  <ng-container *ngIf="FORMS.includes(exam.ExamType)">
                    <span
                      class="l-fg1 examlink"
                      (click)="goExam(null, exam, exam.ExamType, exam.CreationTime)"
                      (contextmenu)="askDelete(exam)"
                    >
                      {{
                        ('GUI.Letters.' + exam.ChangedExamTitle | translate) ||
                          ('GUI.Patient History.ExamTypes.Letter' | translate)
                      }}
                      <ng-container *ngIf="exam.Locked">
                        <img src="../../assets/icons/login/password.svg" style="height: 1em" />
                        {{ exam.LockedBy }}
                      </ng-container>
                    </span>
                    <img
                      *ngIf="exam.ReferralId"
                      src="../../assets/icons/blood-test-referral.svg"
                      style="height: 1.5em; cursor: pointer; background:#277382; border:1px solid #277382; border-radius:4px; padding:3px; box-sizing:content-box; vertical-align:middle"
                      matTooltip="הפניה לבדיקות מעבדה (לחיצה ימנית למחיקה)"
                      (click)="openReferralPrintout(exam.ReferralId)"
                      (contextmenu)="askDeleteReferral(exam, $event)"
                    />
                    <span style="margin-right: 2em">
                      <!-- by -->
                      {{ 'GUI.Patient History.by' | translate }}
                      {{ exam.Opener }}
                    </span>
                    <span class="linked-radios-date">
                      {{ exam.CreationTime | date: 'dd/MM/yyyy' }}
                      <!-- at -->
                      {{ 'GUI.Patient History.at' | translate }}
                      {{ exam.CreationTime | date: 'HH:mm' }}
                    </span>
                  </ng-container>
                </li>
              </ul>
            </div>
            <!-- ========================== Patient Clinial Documents (Start) ========================== -->
            <ng-container *ngIf="login.premissions && login.premissions?.uploadDocuments">
              <div
                class="linked-radios-list linked-radios-set"
                *ngIf="AttachedDocuments && AttachedDocuments?.length > 0"
              >
                <strong class="linked-radios-row" style="margin-bottom: 1em">
                  {{ 'GUI.documents.labels.Attached Clinical Documents' | translate }}
                </strong>

                <ul>
                  <li
                    class="l-flex l-flex-c"
                    *ngFor="let document of AttachedDocuments | sortCreationTime: 'CreationTime'"
                  >
                    <span
                      class="l-fg1 examlink"
                      (click)="openDocument(document.AutoIndex)"
                      (contextmenu)="askDelete(document, false, false, false, false, true)"
                    >
                      {{ document.title }}
                    </span>

                    <span style="margin-right: 2em"> {{ document.comments }}</span>
                    <span class="linked-radios-date"
                      >{{ document.CreationTime | date: 'dd/MM/yyyy' }} at
                      {{ document.CreationTime | date: 'HH:mm' }}
                    </span>
                  </li>
                </ul>
              </div>
              <!-- ========================== Patient Clinial Documents (End) ========================== -->

              <!-- ========================== Patient Administrative Documents (Start) ========================== -->
              <div
                class="linked-radios-list linked-radios-set"
                *ngIf="AttachedAdminDocuments && AttachedAdminDocuments?.length > 0"
              >
                <strong class="linked-radios-row" style="margin-bottom: 1em">
                  {{ 'GUI.documents.labels.Attached Administrative Documents' | translate }}
                </strong>

                <ul>
                  <li
                    class="l-flex l-flex-c"
                    *ngFor="
                      let document of AttachedAdminDocuments | sortCreationTime: 'CreationTime'
                    "
                  >
                    <span
                      class="l-fg1 examlink"
                      (click)="openDocument(document.AutoIndex)"
                      (contextmenu)="askDelete(document, false, false, false, false, true)"
                    >
                      {{ document.title }}
                    </span>

                    <span style="margin-right: 2em"> {{ document.comments }}</span>
                    <span class="linked-radios-date"
                      >{{ document.CreationTime | date: 'dd/MM/yyyy' }} at
                      {{ document.CreationTime | date: 'HH:mm' }}
                    </span>
                  </li>
                </ul>
              </div>
            </ng-container>
            <!-- ========================== Patient Administrative Documents (End) ========================== -->
          </div>
        </div>
        <!-- ========================== Patient History Panel (End) ========================== -->

        <!-- ========================== Create New Exam Panel (Start) ========================== -->
        <div class="w50 patient-ob-box">
          <div class="h100 m-box">
            <h2>
              {{
                !isDefaultsPage
                  ? ('GUI.Patient History.Create New' | translate)
                  : ('GUI.Patient History.Exams Defaults Setting' | translate)
              }}
            </h2>

            <div class="h100 l-flex l-column" style="height: fit-content">
              <div class="l-fg1">
                <div class="">
                  <!-- ========================== New Exam Type Selector (Start) ========================== -->
                  <div class="l-flex-c l-flex-w l-justify h50 new_exam-head">
                    <label class="t-label-top" *ngIf="login.category.name !== 'forms'">
                      <input
                        type="radio"
                        name="TEMP_name"
                        [(ngModel)]="etype"
                        class="custom-check"
                        value="OB STD"
                      />
                      <i class="customInput-display"></i>
                      <span>
                        {{ 'GUI.Patient History.ExamTypes.OB.OB' | translate }}
                      </span>
                    </label>

                    <label class="t-label-top" *ngIf="login.category.name !== 'forms'">
                      <input
                        type="radio"
                        name="TEMP_name"
                        [(ngModel)]="etype"
                        class="custom-check"
                        value="GYN"
                      />
                      <i class="customInput-display"></i>
                      <span>
                        {{ 'GUI.Patient History.ExamTypes.GYN.GYN' | translate }}
                      </span>
                    </label>
                    <label
                      class="t-label-top"
                      *ngIf="login.category.name !== 'forms' && login.premissions?.Pediatric"
                    >
                      <input
                        type="radio"
                        name="TEMP_name"
                        [(ngModel)]="etype"
                        class="custom-check"
                        value="Other Exams"
                      />
                      <i class="customInput-display"></i>
                      <span>
                        {{ 'GUI.Patient History.Other Exams' | translate }}
                      </span>
                    </label>
                    <label class="t-label-top" *ngIf="login.invasiveExams">
                      <input
                        type="radio"
                        name="TEMP_name"
                        [(ngModel)]="etype"
                        class="custom-check"
                        value="Invasive"
                      />
                      <i class="customInput-display"></i>
                      <span> Invasive </span>
                    </label>
                    <label class="t-label-top">
                      <input
                        type="radio"
                        name="TEMP_name"
                        [(ngModel)]="etype"
                        class="custom-check"
                        value="Forms"
                        style="display: none"
                      />
                      <i class="customInput-display"></i>
                      <span>
                        {{ 'GUI.Patient History.ExamTypes.Letters and Certificates' | translate }}
                      </span>
                    </label>
                  </div>
                  <!-- ========================== New Exam Type Selector (End) ========================== -->

                  <div class="linked-radios-list linked-radios-set">
                    <ng-container *ngIf="etype === 'OB STD'">
                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="1st"
                          [(ngModel)]="examname"
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">
                            {{ 'GUI.Patient History.ExamTypes.OB.1st' | translate }}
                          </span>
                          <span class="linked-radios-duration"
                            ><img
                              *ngIf="defaults && defaults['1st']"
                              src="../../assets/icons/del.svg"
                              matTooltip="Delete"
                              (click)="deleteDefault('1st')"
                            />
                            1-9 {{ 'GUI.Patient History.Weeks' | translate }}
                          </span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>

                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="NT"
                          [(ngModel)]="examname"
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">
                            {{ 'GUI.Patient History.ExamTypes.OB.NT' | translate }}
                          </span>
                          <span class="linked-radios-duration"
                            ><img
                              *ngIf="defaults && defaults['NT']"
                              src="../../assets/icons/del.svg"
                              matTooltip="Delete"
                              (click)="deleteDefault('NT')"
                            />
                            11-14 {{ 'GUI.Patient History.Weeks' | translate }}</span
                          >
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>

                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Early"
                          [(ngModel)]="examname"
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">
                            {{ 'GUI.Patient History.ExamTypes.OB.Early' | translate }}
                          </span>
                          <span class="linked-radios-duration"
                            ><img
                              *ngIf="defaults && defaults['Early']"
                              src="../../assets/icons/del.svg"
                              matTooltip="Delete"
                              (click)="deleteDefault('Early')"
                            />
                            14-16 {{ 'GUI.Patient History.Weeks' | translate }}</span
                          >
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>

                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="2nd/3rd"
                          [(ngModel)]="examname"
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">
                            {{ 'GUI.Patient History.ExamTypes.OB.2nd/3rd' | translate }}
                          </span>
                          <span class="linked-radios-duration"
                            ><img
                              *ngIf="defaults && defaults['2nd/3rd']"
                              src="../../assets/icons/del.svg"
                              matTooltip="Delete"
                              (click)="deleteDefault('2nd/3rd')"
                            />
                            12-40 {{ 'GUI.Patient History.Weeks' | translate }}</span
                          >
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>

                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Weight Assessment"
                          [(ngModel)]="examname"
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">
                            {{ 'GUI.Patient History.ExamTypes.OB.Weight Assessment' | translate }}
                          </span>
                          <span class="linked-radios-duration"
                            ><img
                              *ngIf="defaults && defaults['Weight Assessment']"
                              src="../../assets/icons/del.svg"
                              matTooltip="Delete"
                              (click)="deleteDefault('Weight Assessment')"
                            />
                            12-40 {{ 'GUI.Patient History.Weeks' | translate }}</span
                          >
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Late"
                          [(ngModel)]="examname"
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">
                            {{ 'GUI.Patient History.ExamTypes.OB.Late' | translate }}
                          </span>
                          <span class="linked-radios-duration"
                            ><img
                              *ngIf="defaults && defaults['Late']"
                              src="../../assets/icons/del.svg"
                              matTooltip="Delete"
                              (click)="deleteDefault('Late')"
                            />
                            21-24 {{ 'GUI.Patient History.Weeks' | translate }}</span
                          >
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                      <label class="linked-radios-item" *ngIf="login.premissions.thirdScan">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Third Scan"
                          [(ngModel)]="examname"
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">
                            {{ 'GUI.Patient History.ExamTypes.OB.Third Scan' | translate }}
                          </span>
                          <span class="linked-radios-duration"
                            ><img
                              *ngIf="defaults && defaults['Third Scan']"
                              src="../../assets/icons/del.svg"
                              matTooltip="Delete"
                              (click)="deleteDefault('Third Scan')"
                            />
                            28-33 {{ 'GUI.Patient History.Weeks' | translate }}</span
                          >
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>

                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Specialized"
                          [(ngModel)]="examname"
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">
                            {{ 'GUI.Patient History.ExamTypes.OB.Specialized' | translate }}
                          </span>
                          <span class="linked-radios-duration"
                            ><img
                              *ngIf="defaults && defaults['Specialized']"
                              src="../../assets/icons/del.svg"
                              matTooltip="Delete"
                              (click)="deleteDefault('Specialized')"
                            />
                            12-40 {{ 'GUI.Patient History.Weeks' | translate }}</span
                          >
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>

                      <!-- Specialized Sub-types 1-8 -->
                      <div *ngIf="examname === 'Specialized'" style="margin-left: 2em">
                        <label class="linked-radios-item">
                          <input
                            type="radio"
                            name="TEMP_specialized"
                            value="Brain and CNS"
                            [(ngModel)]="examSubType"
                          />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">{{
                              'exam.type.OBS.Brain and CNS' | translate
                            }}</span>
                            <span class="linked-radios-duration"
                              ><img
                                *ngIf="defaults && defaults['Specialized_Brain and CNS']"
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete Default"
                                (click)="deleteDefault('Specialized', 'Brain and CNS')"
                            /></span>
                          </span>
                        </label>
                        <label class="linked-radios-item">
                          <input
                            type="radio"
                            name="TEMP_specialized"
                            value="Cardiovascular"
                            [(ngModel)]="examSubType"
                          />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">{{
                              'exam.type.OBS.Cardiovascular' | translate
                            }}</span>
                            <span class="linked-radios-duration"
                              ><img
                                *ngIf="defaults && defaults['Specialized_Cardiovascular']"
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete Default"
                                (click)="deleteDefault('Specialized', 'Cardiovascular')"
                            /></span>
                          </span>
                        </label>
                        <label class="linked-radios-item">
                          <input
                            type="radio"
                            name="TEMP_specialized"
                            value="Kidneys and Urinary Tract"
                            [(ngModel)]="examSubType"
                          />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">{{
                              'exam.type.OBS.Kidneys and Urinary Tract' | translate
                            }}</span>
                            <span class="linked-radios-duration"
                              ><img
                                *ngIf="
                                  defaults && defaults['Specialized_Kidneys and Urinary Tract']
                                "
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete Default"
                                (click)="deleteDefault('Specialized', 'Kidneys and Urinary Tract')"
                            /></span>
                          </span>
                        </label>
                        <label class="linked-radios-item">
                          <input
                            type="radio"
                            name="TEMP_specialized"
                            value="Gastroenteric Tract"
                            [(ngModel)]="examSubType"
                          />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">{{
                              'exam.type.OBS.Gastroenteric Tract' | translate
                            }}</span>
                            <span class="linked-radios-duration"
                              ><img
                                *ngIf="defaults && defaults['Specialized_Gastroenteric Tract']"
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete Default"
                                (click)="deleteDefault('Specialized', 'Gastroenteric Tract')"
                            /></span>
                          </span>
                        </label>
                        <label class="linked-radios-item">
                          <input
                            type="radio"
                            name="TEMP_specialized"
                            value="Skeletal"
                            [(ngModel)]="examSubType"
                          />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">{{
                              'exam.type.OBS.Skeletal' | translate
                            }}</span>
                            <span class="linked-radios-duration"
                              ><img
                                *ngIf="defaults && defaults['Specialized_Skeletal']"
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete Default"
                                (click)="deleteDefault('Specialized', 'Skeletal')"
                            /></span>
                          </span>
                        </label>
                        <label class="linked-radios-item">
                          <input
                            type="radio"
                            name="TEMP_specialized"
                            value="Polyhydramnios"
                            [(ngModel)]="examSubType"
                          />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">{{
                              'exam.type.OBS.Polyhydramnios' | translate
                            }}</span>
                            <span class="linked-radios-duration"
                              ><img
                                *ngIf="defaults && defaults['Specialized_Polyhydramnios']"
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete Default"
                                (click)="deleteDefault('Specialized', 'Polyhydramnios')"
                            /></span>
                          </span>
                        </label>
                        <label class="linked-radios-item">
                          <input
                            type="radio"
                            name="TEMP_specialized"
                            value="PCS Placenta and Blood"
                            [(ngModel)]="examSubType"
                          />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">{{
                              'exam.type.OBS.PCS Placenta and Blood' | translate
                            }}</span>
                            <span class="linked-radios-duration"
                              ><img
                                *ngIf="defaults && defaults['Specialized_PCS Placenta and Blood']"
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete Default"
                                (click)="deleteDefault('Specialized', 'PCS Placenta and Blood')"
                            /></span>
                          </span>
                        </label>
                        <label class="linked-radios-item" style="margin-bottom: 0.5em">
                          <input
                            type="radio"
                            name="TEMP_specialized"
                            value="Other"
                            [(ngModel)]="examSubType"
                          />
                          <span class="linked-radios-row">
                            <span class="l-fg1 linked-radios-title">{{
                              'exam.type.OBS.Other' | translate
                            }}</span>
                            <span class="linked-radios-duration"
                              ><img
                                *ngIf="defaults && defaults['Specialized_Other']"
                                src="../../assets/icons/del.svg"
                                matTooltip="Delete Default"
                                (click)="deleteDefault('Specialized', 'Other')"
                            /></span>
                          </span>
                        </label>
                      </div>

                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Fetal Echo"
                          [(ngModel)]="examname"
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">
                            {{ 'GUI.Patient History.ExamTypes.OB.Fetal Echo' | translate }}
                          </span>
                          <span class="linked-radios-duration"
                            ><img
                              *ngIf="defaults && defaults['Fetal Echo']"
                              src="../../assets/icons/del.svg"
                              matTooltip="Delete"
                              (click)="deleteDefault('Fetal Echo')"
                            />
                            12-40 {{ 'GUI.Patient History.Weeks' | translate }}</span
                          >
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                    </ng-container>

                    <ng-container *ngIf="etype === 'Forms'">
                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Consultation Letter"
                          [(ngModel)]="examname"
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">
                            {{ 'GUI.Patient History.ExamTypes.Letter' | translate }}
                          </span>
                          <span class="linked-radios-duration"></span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                      <label class="linked-radios-item" *ngIf="login.premissions?.Consent">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Inform Consent"
                          [(ngModel)]="examname"
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">
                            {{ 'GUI.Patient History.ExamTypes.Informed Consent' | translate }}
                            <span
                              *ngIf="login.premissions?.concentLimit"
                              style="align-self: center; margin-inline-start: 2.31em"
                              [ngClass]="
                                login.concentCount >= login.premissions?.concentLimit ? 'error' : ''
                              "
                            >
                              {{ login.concentCount }}/{{ login.premissions?.concentLimit }}
                            </span>
                          </span>
                          <span class="linked-radios-duration"></span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                      <label class="linked-radios-item" *ngIf="login.premissions?.Questionnaires">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Send Questionnaire"
                          [(ngModel)]="examname"
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">
                            {{ 'appointments.gui.questionnaires.New Questionnaire' | translate }}
                          </span>
                          <span class="linked-radios-duration"></span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                    </ng-container>
                    <ng-container *ngIf="etype === 'GYN'">
                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Gynecology"
                          [(ngModel)]="examname"
                          checked
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">
                            {{ 'GUI.Patient History.ExamTypes.GYN.Gynecology' | translate }}
                          </span>
                          <span class="linked-radios-duration"
                            ><img
                              *ngIf="defaults && defaults['Gynecology']"
                              src="../../assets/icons/del.svg"
                              matTooltip="Delete"
                              (click)="deleteDefault('Gynecology')"
                            />
                          </span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                    </ng-container>

                    <ng-container *ngIf="etype === 'Other Exams' && login.premissions?.Pediatric">
                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Pediatric Echo"
                          [(ngModel)]="examname"
                          checked
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title"> Pediatric Echo </span>
                          <span class="linked-radios-duration">
                            <img
                              *ngIf="defaults && defaults['Pediatric Echo']"
                              src="../../assets/icons/del.svg"
                              matTooltip="Delete"
                              (click)="deleteDefault('Pediatric Echo')"
                            />
                          </span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                    </ng-container>

                    <ng-container *ngIf="etype === 'Invasive'">
                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="Amniocentesis"
                          [(ngModel)]="examname"
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">Amniocentesis</span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                      <label class="linked-radios-item">
                        <input
                          type="radio"
                          name="TEMP_name1"
                          value="CVS"
                          [(ngModel)]="examname"
                          (change)="onExamTypeChange()"
                        />
                        <span class="linked-radios-row">
                          <span class="l-fg1 linked-radios-title">CVS</span>
                          <span class="linked-radios-counter"><i>1</i></span>
                        </span>
                      </label>
                    </ng-container>
                  </div>
                </div>
              </div>
              <ng-container
                *ngIf="
                  etype === 'Forms' &&
                  login.premissions?.Consent &&
                  (login.userType === 'secretary' || login.userType === 'doctor')
                "
              >
                <label
                  class="t-label-top"
                  style="margin-top: 1em"
                  *ngIf="examname === 'Inform Consent'"
                >
                  <span> Exam Type </span>
                  <select class="t-select t-field" [(ngModel)]="examServe.consentExamType">
                    <option></option>
                    <option value="1st">
                      {{ 'GUI.Patient History.ExamTypes.OB.1st' | translate }}
                    </option>
                    <option value="NT">
                      {{ 'GUI.Patient History.ExamTypes.OB.NT' | translate }}
                    </option>
                    <option value="Early">
                      {{ 'GUI.Patient History.ExamTypes.OB.Early' | translate }}
                    </option>
                    <option value="2nd/3rd">
                      {{ 'GUI.Patient History.ExamTypes.OB.2nd/3rd' | translate }}
                    </option>
                    <option value="Weight Assessment">
                      {{ 'GUI.Patient History.ExamTypes.OB.Weight Assessment' | translate }}
                    </option>
                    <option value="Late">
                      {{ 'GUI.Patient History.ExamTypes.OB.Late' | translate }}
                    </option>
                    <option *ngIf="login.premissions.thirdScan" value="Third Scan">
                      {{ 'GUI.Patient History.ExamTypes.OB.Third Scan' | translate }}
                    </option>
                    <option value="Specialized">
                      {{ 'GUI.Patient History.ExamTypes.OB.Specialized' | translate }}
                    </option>
                    <option value="Fetal Echo">
                      {{ 'GUI.Patient History.ExamTypes.OB.Fetal Echo' | translate }}
                    </option>
                    <option value="Gynecology">Gynecology</option>
                  </select>
                </label>
                <label
                  class="t-label-top"
                  style="margin-top: 1em"
                  *ngIf="
                    examname === 'Inform Consent' &&
                    examServe.consentExamType === 'Gynecology' &&
                    login.premissions?.Consent
                  "
                >
                  <span> Consent Type </span>
                  <select class="t-select t-field" [(ngModel)]="selectedGynConsentType">
                    <option value="" disabled>Select Consent Type</option>
                    <option value="Hysterosalpingo Sonography">Hysterosalpingo Sonography</option>
                    <option value="Insertion of IUD">Insertion of IUD</option>
                  </select>
                </label>
                <ng-container *ngIf="clinicPractitioners?.length > 1 && !login.separatedClinic">
                  <label
                    class="t-label-top"
                    style="margin-top: 1em"
                    *ngIf="examname === 'Inform Consent' && login.userType !== 'doctor'"
                  >
                    <span> Clinic's US Practitioners: </span>
                    <select
                      class="t-select t-field"
                      [(ngModel)]="examServe.consentPractitioner"
                      (ngModelChange)="setConsentDocUID()"
                    >
                      <option value=""></option>
                      <ng-container *ngFor="let option of clinicPractitioners">
                        <option [value]="option.Title + ' ' + option.Name">
                          {{ option.Title }} {{ option.Name }}
                        </option>
                      </ng-container>
                    </select>
                  </label>
                </ng-container>
              </ng-container>

              <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">
                <a class="patient-ob-btn -exit_patient" routerLink="/patsearch">
                  {{
                    !isDefaultsPage
                      ? ('GUI.General.Buttons.Exit Patient' | translate)
                      : ('GUI.General.Buttons.Exit Defaults' | translate)
                  }}
                </a>
                <button
                  class="patient-ob-btn -start_exam"
                  [ngClass]="
                    (examname &&
                      etype &&
                      !examServe.awaitPrintHistory &&
                      !(examname === 'Specialized' && !examSubType)) ||
                    (isDefaultsPage && examname && etype)
                      ? ''
                      : 'opaque'
                  "
                  [disabled]="
                    !login.category.canCreate.exam || (examname === 'Specialized' && !examSubType)
                  "
                  (click)="
                    etype !== 'Forms' && login.category.canCreate.exam
                      ? (shouldOpenExam = true)
                      : null;
                    startExam()
                  "
                  *ngIf="canOpen() && examname !== 'Inform Consent'"
                >
                  {{
                    !isDefaultsPage
                      ? examname === 'Send Questionnaire'
                        ? ('appointments.gui.questionnaires.New Questionnaire' | translate)
                        : etype !== 'Forms'
                          ? ('GUI.General.Buttons.Start Exam' | translate)
                          : ('GUI.General.Buttons.New Letter' | translate)
                      : ('GUI.General.Buttons.Construct/Edit Defaults' | translate)
                  }}
                </button>
                <button
                  class="patient-ob-btn -start_exam"
                  [ngClass]="
                    examname &&
                    etype &&
                    (examServe.consentExamType === 'Gynecology'
                      ? selectedGynConsentType
                      : examServe.consentExamType && examServe.consentDocUID)
                      ? ''
                      : 'opaque'
                  "
                  [disabled]="
                    !login.premissions?.Consent ||
                    (examServe.consentExamType === 'Gynecology' && !selectedGynConsentType) ||
                    (examServe.consentExamType !== 'Gynecology' &&
                      (!examServe.consentExamType || !examServe.consentDocUID))
                  "
                  (click)="
                    examServe.consentExamType === 'Gynecology' ? startGynForm() : startForm()
                  "
                  *ngIf="examname === 'Inform Consent' && etype === 'Forms'"
                >
                  {{ !isDefaultsPage ? 'New Form' : 'Construct/Edit Defaults' }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- ========================== Create New Exam Panel (End) ========================== -->
      </div>
      <!-- box margin -->
    </main>
    <!-- ========================== Dashboard Main Content (End) ========================== -->

    <!-- ========================== main sidebar (end) ========================== -->

    <app-bottombar></app-bottombar>
  </div>
  <!-- end wrapper -->
  <!-- ========================== Delete Confirmation Popup (Start) ========================== -->
  <div
    class="t-popup popup-patientDetails"
    *ngIf="toDelete"
    style="display: block; max-width: 40vw"
  >
    <div class="t-popup-frame">
      <div class="t-popup-body">
        <button
          class="t-btn-popup-close"
          aria-label="close popup"
          (click)="toDelete = null; readydelete = false"
        ></button>
        <h2 *ngIf="documentDelete" style="color: #d7a95b">
          {{
            'Delete ' +
              toDelete.title +
              ' document from ' +
              (toDelete.CreationTime | date: 'd/M/yy, HH:mm a')
          }}?
        </h2>
        <h2 *ngIf="plannerToDelete" style="color: #d7a95b">
          {{
            'Delete Pregnancy Planner from ' + (toDelete.CreationTime | date: 'd/M/yy, HH:mm a')
          }}?
        </h2>
        <h2 *ngIf="!plannerToDelete && !documentDelete" style="color: #d7a95b">
          {{ 'GUI.Patient History.Delete' | translate }} {{ toDelete.ExamType }}
          {{
            defaults ? 'defaults' : 'exam from today at ' + (toDelete.CreationTime | date: 'HH:mm')
          }}?
        </h2>
        <div *ngIf="!readydelete">
          <button (click)="readydelete = true">
            {{ 'general.PositiveNegative.yes' | translate }}
          </button>
          <button (click)="toDelete = null; readydelete = false" style="margin-left: 2em">
            {{ 'general.PositiveNegative.No' | translate }}
          </button>
        </div>
        <div *ngIf="readydelete && plannerToDelete">
          <strong>
            WARNING Pregnancy Planner Data Will Be Lost!
            <br />
          </strong>
          <button (click)="cf.deleteCalendar(); toDelete = null; readydelete = false">OK</button>
          <button (click)="toDelete = null; readydelete = false" style="margin-left: 2em">
            Cancel
          </button>
        </div>
        <div *ngIf="readydelete && documentDelete">
          <strong>
            WARNING document Will Be Lost!
            <br />
          </strong>
          <button
            (click)="deleteDocument(); toDelete = null; readydelete = false; documentDelete = false"
          >
            OK
          </button>
          <button
            (click)="toDelete = null; readydelete = false; documentDelete = false"
            style="margin-left: 2em"
          >
            Cancel
          </button>
        </div>
        <div *ngIf="readydelete && !plannerToDelete && !documentDelete">
          WARNING exam data and media will we lost!<br />
          <button (click)="deleteExam(); readydelete = false">OK</button>
          <button (click)="toDelete = null; readydelete = false" style="margin-left: 2em">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- ========================== Delete Confirmation Popup (End) ========================== -->

  <!-- ========================== Delete Referral Confirmation Popup (Start) ========================== -->
  <div
    class="t-popup popup-patientDetails"
    *ngIf="referralToDelete"
    style="display: block; max-width: 40vw"
  >
    <div class="t-popup-frame" style="max-width: 30em">
      <div class="t-popup-body">
        <button
          class="t-btn-popup-close"
          aria-label="close popup"
          (click)="referralToDelete = null; referralDeleteReady = false"
        ></button>
        <h2 style="color: #d7a95b; text-align: center">
          {{ 'GUI.Patient History.Delete Referral' | translate }}
        </h2>
        <p style="text-align: center">
          {{ 'GUI.Patient History.Delete Referral Confirm' | translate }}
        </p>
        <div style="display: flex; justify-content: space-evenly">
          <button
            (click)="confirmDeleteReferral()"
            style="min-width: 7em; background: #d7a95b; color: #fff; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer"
          >
            {{ 'GUI.Buttons.Delete' | translate }}
          </button>
          <button
            (click)="referralToDelete = null; referralDeleteReady = false"
            style="min-width: 7em; background: #277382; color: #fff; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer"
          >
            {{ 'GUI.Buttons.Cancel' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- ========================== Delete Referral Confirmation Popup (End) ========================== -->

  <!-- ========================== Dynamic Popup Components (Start) ========================== -->
  <app-patdetails
    *ngIf="showPat"
    [pat]="pat"
    (closed)="showPat = false"
    (show_surrogate)="show_surrogate = true"
  ></app-patdetails>
  <app-surrogate
    *ngIf="show_surrogate"
    (closed)="show_surrogate = false"
    [genMom]="pat"
  ></app-surrogate>
  <app-patforms *ngIf="typeForm" (closed)="typeForm = false"></app-patforms>
  <app-informconcent
    *ngIf="inform"
    (closed)="closCalForm($event)"
    [form]="concentForm"
    [ExamType]="etype === 'Forms' ? examServe.consentExamType : examname"
  ></app-informconcent>
  <app-gyn-consent
    *ngIf="showGynConsent"
    (closed)="closeGYNConsentSelect($event)"
    [form]="concentForm"
    [ExamType]="etype === 'Forms' ? examServe.consentExamType : examname"
    [consentType]="selectedGynConsentType"
  ></app-gyn-consent>
  <app-pat-documents
    *ngIf="openDocumentsAdd"
    (closed)="openDocumentsAdd = false; resetPregs()"
  ></app-pat-documents>
  <app-commerror></app-commerror>
  <app-calexams
    *ngIf="calendarForm"
    (closed)="closCalForm($event)"
    [selectedForm]="selectedForm"
  ></app-calexams>
  <app-loginbox
    *ngIf="showLogin"
    (closed)="showLogin = false"
    (viewonly)="viewonly()"
    [isnew]="newExam"
  ></app-loginbox>
  <app-closepregnancy
    *ngIf="closePreg"
    [pregtoload]="closePreg"
    [exams]="pregExams"
    (examClosed)="pregClosed()"
    (closed)="closePreg = null"
  ></app-closepregnancy>
  <app-send-questionnaire
    *ngIf="showSendQuestionnaire"
    [patient]="sendQuestionnairePatient"
    (closed)="onSendQuestionnaireClosed()"
  ></app-send-questionnaire>
  <!-- ========================== Dynamic Popup Components (End) ========================== -->
</div>
